import React from "react";

interface IProps {}

export const NotFound: React.FC<IProps> = (props: IProps): React.ReactElement => {
  return <div>Not found</div>;
};